var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "select" }, [
    _c(
      "div",
      { staticClass: "select__wrapper" },
      [
        _c("multiselect", {
          attrs: {
            options: _vm.options,
            multiple: true,
            searchable: false,
            "close-on-select": false,
            "clear-on-select": false,
            "preserve-search": false,
            "selected-label": "Выбран",
            "select-label": "",
            "deselect-label": "",
            "delete-label": "",
            placeholder: "Корпус",
            label: "title",
            "track-by": "name"
          },
          on: { close: _vm.selectClose },
          scopedSlots: _vm._u([
            {
              key: "selection",
              fn: function(ref) {
                var values = ref.values
                var search = ref.search
                var isOpen = ref.isOpen
                return [
                  values.length && !isOpen
                    ? _c("span", { staticClass: "multiselect__single" }, [
                        _vm._v(
                          "Корпусов выбрано: " +
                            _vm._s(values.length) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]
              }
            }
          ]),
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }